module.exports = __webpack_public_path__ + "img/yellow-circle-table-6.8fdf6c3a.png";